export const latest = [
	{
		id: 1,
		title: 'Suit',
		price: '$ 50.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657076838/srwzn7qahlzboxon06yb.jpg',
	},
	{
		id: 2,
		title: 'Blause',
		price: '$ 46.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657076897/ehymfw0bfceps0whggb6.png',
	},
	{
		id: 3,
		title: 'Suit',
		price: '$ 30.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657076838/srwzn7qahlzboxon06yb.jpg',
	},
	{
		id: 4,
		title: 'Suit',
		price: '$ 46.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657076838/srwzn7qahlzboxon06yb.jpg',
	},
];
export const featured = [
	{
		id: 5,
		title: 'Coat',
		price: '$ 30.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657279617/hrugj24fhzbtnlhkzsw0.png',
	},
	{
		id: 6,
		title: 'Coat',
		price: '$ 30.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657279617/hrugj24fhzbtnlhkzsw0.png',
	},
	{
		id: 7,
		title: 'Coat',
		price: '$ 30.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657279617/hrugj24fhzbtnlhkzsw0.png',
	},
	{
		id: 8,
		title: 'Coat',
		price: '$ 30.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657279617/hrugj24fhzbtnlhkzsw0.png',
	},
];

export const hot = [
	{
		id: 9,
		title: 'T-Shirt',
		price: '$ 12.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657279545/wird81nqg4crkxs2ddnk.jpg',
	},
	{
		id: 10,
		title: 'T-Shirt',
		price: '$ 12.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657279545/wird81nqg4crkxs2ddnk.jpg',
	},
	{
		id: 11,
		title: 'T-Shirt',
		price: '$ 12.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657279545/wird81nqg4crkxs2ddnk.jpg',
	},
	{
		id: 12,
		title: 'T-Shirt',
		price: '$ 12.90',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657279545/wird81nqg4crkxs2ddnk.jpg',
	},
];

export const arrivals = [
	{
		id: 13,
		title: 'Deals of the Day',
		caption: 'Up to 60% Off',
		photo: 'https://res.cloudinary.com/fichua-store/',
	},
	{
		id: 14,
		title: 'Clearance Sale',
		caption: 'Up to 60% Off',
		photo: 'https://res.cloudinary.com/fichua-store/',
	},
	{
		id: 14,
		title: 'Doorstep Delivery',
		caption: 'Enjoy up to 25% off',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657338908/sale-three_zneyuj.jpg',
	},
];

export const deals = [
	{
		id: 15,
		title: 'Deals on  Groceries',
		slug: 'category/grocories/037453bb-a595-4111-81c7-ff03c92cbab5',
		caption: 'Up to 60% Off',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657338963/berries-two_icsnhf.jpg',
	},
	{
		id: 16,
		title: 'Deals on  Computers',
		slug: '/category/electronics/3a000ce5-f591-4806-b8e5-6a63f71d49a1',
		caption: 'Up to 60% Off',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657338930/tech-fifteen_qwfd3s.jpg',
	},
	{
		id: 17,
		title: 'Deals on  Shoes',
		slug: 'category/fashion/3d815131-b9b9-42df-9753-c606e911ef7b',
		caption: 'Enjoy up to 25% off',
		photo:
			'https://res.cloudinary.com/fichua-store/image/upload/v1657339002/men-official-shoes_i1dswt.jpg',
	},
];
